module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-charges"
  }, [_c('h1', [_vm._v("水电充值报表")]), _c('month-select', {
    attrs: {
      "start": _vm.date_start,
      "end": _vm.date_end,
      "mode": "years"
    },
    on: {
      "update:start": function($event) {
        _vm.date_start = $event
      },
      "update:end": function($event) {
        _vm.date_end = $event
      }
    }
  }), _c('table', {
    staticClass: "ui celled structured table fixed olive"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.data), function(row, irow) {
    return _c('tr', {
      class: {
        summary: irow === _vm.data.length - 1
      }
    }, _vm._l((row), function(value, icol) {
      return _c('td', {
        staticClass: "right aligned",
        class: {
          positive: icol === 9
        }
      }, [_vm._v(_vm._s(value))])
    }))
  }))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "center aligned",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("楼层")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("电")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("冷水")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("热水")]), _c('th', {
    staticClass: "center aligned",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("厨房")]), _c('th', {
    staticClass: "center aligned positive",
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("汇总")])]), _c('tr', [_c('th', {
    staticClass: "center aligned"
  }, [_vm._v("千瓦时")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("金额")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("吨")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("金额")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("吨")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("金额")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("吨")]), _c('th', {
    staticClass: "center aligned"
  }, [_vm._v("金额")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ccd3b4c","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/reports/Charges.vue
// module id = 479
// module chunks = 0